import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Alert,
  Stack,
  CircularProgress,
  Box,
} from "@mui/material";

const formatCurrency = (value) =>
  value == null
    ? "—"
    : new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
      }).format(value);

export default function MappingPriceDialog({
  open,
  onClose,
  loading,
  pricing,
  mappingLabel,
}) {
  const lines = pricing?.lines || [];
  const warnings = pricing?.warnings || [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Price Breakdown{mappingLabel ? ` — ${mappingLabel}` : ""}</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Stack spacing={2}>
            {warnings.length > 0 && (
              <Alert severity="warning">
                {warnings.map((w, i) => (
                  <div key={i}>{w}</div>
                ))}
              </Alert>
            )}

            {lines.length === 0 ? (
              <Typography color="text.secondary">
                No items in this mapping.
              </Typography>
            ) : (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Item / Set</TableCell>
                    <TableCell>Vendor</TableCell>
                    <TableCell align="right">Qty</TableCell>
                    <TableCell align="right">Unit Price</TableCell>
                    <TableCell align="right">Cost Price</TableCell>
                    <TableCell align="right">Line Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {lines.map((line, idx) => (
                    <TableRow key={`${line.type}-${line.name}-${idx}`}>
                      <TableCell>
                        {line.type === "collection" ? "[Set] " : ""}
                        {line.name}
                      </TableCell>
                      <TableCell>{line.vendorName || "—"}</TableCell>
                      <TableCell align="right">{line.quantity}</TableCell>
                      <TableCell align="right">
                        {formatCurrency(line.unitPrice)}
                      </TableCell>
                      <TableCell align="right">
                        {formatCurrency(line.costPrice)}
                      </TableCell>
                      <TableCell align="right">
                        {formatCurrency(line.lineTotal)}
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell colSpan={5} align="right">
                      <strong>Total</strong>
                    </TableCell>
                    <TableCell align="right">
                      <strong>{formatCurrency(pricing?.totalPrice)}</strong>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            )}
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
